export function setValue(elem: HTMLInputElement, value: string): void {
  switch (elem.type) {
    case 'checkbox':
    case 'radio':
      elem.checked = value == 'true';
      break;
    case 'file':
      // Do nothing. Setting a file input's value throws.
      break;
    default: {
      const orig = elem.value;
      elem.value = value;
      if (elem.value !== value) {
        // Oops, invalid value
        elem.value = orig;
      }
      break;
    }
  }
}
